import {
  notNullNonNegativeInteger,
  notNullPositiveInteger,
  nullable,
  nullableInteger,
  nullablePositiveInteger
} from 'utils/validations'

type StringOrNull = string | null

type Validations = {
  [key: string]: { validate: (value: StringOrNull) => StringOrNull }
}

const createValidations: Validations = {
  quantity: { validate: notNullPositiveInteger },
  discount: { validate: nullableInteger },
  ordered_at: { validate: nullable },
  minimum_invoice_amount: { validate: notNullNonNegativeInteger },
  fine_amount: { validate: notNullNonNegativeInteger },
  penalty_period: { validate: nullablePositiveInteger }
}

const updateValidations: Validations = {
  quantity: { validate: notNullPositiveInteger },
  discount: { validate: nullableInteger },
  ordered_at: { validate: nullable },
  minimum_invoice_amount: { validate: notNullNonNegativeInteger },
  fine_amount: { validate: notNullNonNegativeInteger },
  penalty_period: { validate: nullablePositiveInteger }
}

export function validateCreation(
  prop: any,
  value: StringOrNull,
  context?: Record<string, any>
): string | null {
  if (!(prop in createValidations)) return null

  const error = createValidations[prop].validate(value)
  if (error) return error

  if (prop === 'penalty_period' && value && context?.duration) {
    if (parseInt(value) > parseInt(String(context.duration))) {
      return `Não pode exceder a duração do plano (${context.duration} meses)`
    }
  }

  return null
}

export function validateUpdate(
  prop: any,
  value: StringOrNull,
  context?: Record<string, any>
): string | null {
  if (!(prop in updateValidations)) return null

  const error = updateValidations[prop].validate(value)
  if (error) return error

  if (prop === 'penalty_period' && value && context?.duration) {
    if (parseInt(value) > parseInt(String(context.duration))) {
      return `Não pode exceder a duração do plano (${context.duration} meses)`
    }
  }

  return null
}
